export enum DRAGGING_STATE {
    IDLE = 'idle',
    DRAGGING = 'dragging',
}
